export const FS_DEFAULT_CONFIG = {
    "ORG_ID" : "o-1V5D6T-na1"
}